import { render, staticRenderFns } from "./DepositsTable.vue?vue&type=template&id=68539dc4&scoped=true&"
var script = {}
import style0 from "./DepositsTable.vue?vue&type=style&index=0&id=68539dc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68539dc4",
  null
  
)

export default component.exports